import React from "react";

interface DateDisplayProps {
  date: string | Date | undefined;
}

function DateDisplay({ date }: DateDisplayProps) {
  if (!date || date === "") return <></>;

  if (typeof date === "string") date = new Date(date);

  let output: string;
  output = date.toLocaleDateString() + " " + date.toLocaleTimeString();

  return <span>{output}</span>;
}

export default DateDisplay;
